import type { Messages } from "@/types/i18n";
import coreEn from "./core/en";
import accountEn from "./features/account/en";
import cardEn from "./features/card/en";
import categoryEn from "./features/category/en";
import cazhboxEn from "./features/cazhbox/en";
import componentsEn from "./features/components/en";
import customerEn from "./features/customer/en";
import dashboardId from "./features/dashboard/id";
import employeeEn from "./features/employee/en";
import inventoryEn from "./features/inventory/en";
import posEn from "./features/pos/en";
import productEn from "./features/product/en";
import profileEn from "./features/profile/en";
import promoEn from "./features/promo/en";
import reportOfflineEn from "./features/report-offline/en";
import reportOnlineEn from "./features/report-online/en";
import storeEn from "./features/store/en";
import supplierEn from "./features/supplier/en";
import systemPointEn from "./features/system-point/en";

const en: Messages = {
	...coreEn,
	...accountEn,
	...profileEn,
	...storeEn,
	...componentsEn,
	...dashboardId,
	...employeeEn,
	...categoryEn,
	...productEn,
	...inventoryEn,
	...customerEn,
	...cardEn,
	...promoEn,
	...systemPointEn,
	...supplierEn,
	...cazhboxEn,
	...reportOfflineEn,
	...reportOnlineEn,
	...posEn,
};

export default en;
